export function sbmProgramsLPM19() {
  $ = jQuery;

  // Initialize
  var firstTab = $('.lpm19_tabs_wrapper .tabs_head .tab_title.tab_id-0');
  firstTab.addClass('active');
  var firstContents = $('.lpm19_wrapper .tabs_content .tab_content.tab_id-0');
  firstContents.addClass('active');
  var firstMobileTitle = $('.lpm19_tab_mobile .tab_title.tab_id-0');
  firstMobileTitle.addClass('active');

  var tabHead = $('.lpm19_tabs_wrapper .tabs_head .tab_title');
  var tabHeadParent = $('.lpm19_tabs_wrapper');
  var tabContents = $('.lpm19_wrapper .tabs_content');
  var tabContainer = $('.lpm19_tabs_container');
  var tabMobileTitle = $('.lpm19_tab_mobile');

  //for open mobile menu
  tabMobileTitle.on('click', function () {
    if (!tabContainer.hasClass('isOpen')) {
      tabContainer.addClass('isOpen');
    } else if (tabContainer.hasClass('isOpen')) {
      tabContainer.removeClass('isOpen');
    }
  });

  tabHead.each(function () {
    var tabTitle = $(this);
    var contentToShow = tabTitle.attr('data-tab');
    var offsetLeft = tabTitle.position().left;
    tabTitle.on('click', function () {
      if (!tabTitle.hasClass('active')) {
        console.log(offsetLeft);
        tabHeadParent.animate({
          scrollLeft: offsetLeft
        });
        tabContents.find('.tab_content').hide().removeClass('active').show();
        tabContents.find(contentToShow).addClass('active');
        tabMobileTitle.find('.tab_title').hide().removeClass('active').show();
        tabMobileTitle.find(contentToShow).addClass('active');
        tabHead.removeClass('active');
        tabTitle.addClass('active');
        tabContainer.removeClass('isOpen');
      }
    });
  });
}
